module.exports = __webpack_public_path__ + "img/roadmap-phase-1-cell-5-icon.6d2fe8c1.svg";